import {toLower, startCase} from 'lodash';
import {I18n} from 'react-redux-i18n';

export const translateOer = oer => {
  const lowerOer = toLower(oer);
  const translatedOer = I18n.t(`filter.oer.${lowerOer}`);
  if (translatedOer !== lowerOer) {
    return translatedOer;
  }

  // it doesn't have a translation
  if (lowerOer === 'stability_control_7') {
    return 'Forward Collision Warning';
  }
  return startCase(lowerOer);
};

export default translateOer;

export const formatDuration = duration => {
  if (!duration) return null;
  const roundedDuration = Math.floor(duration);
  const minutes = parseInt(roundedDuration / 60, 0);
  const seconds = roundedDuration % 60;

  const minStr = (minutes > 0) ? `${minutes} ${I18n.t('defaults.short.minutes')} ` : '';
  const secStr = (seconds > 0) ? `${seconds} ${I18n.t('defaults.short.seconds')}` : '';

  return minStr + secStr;
};

